import ItHeroSection from "./ItHeroSection/ItHeroSection";
import BrandCarousel from "./BrandCarousel/BrandCarousel";
import BgvServiceSection from "./BgvServiceSection/BgvServiceSection";
import BgvStepsSection from "./BgvStepsSection/BgvStepsSection";
import ServicesCardSection from "./ServicesCardSection/ServicesCardSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import { Helmet } from "react-helmet";

const ItPage = () => {
  return (
    <>
      <Helmet>
        <title>Background Verification for IT & ITeS | Hirestar.io</title>
        <meta
          name="description"
          content="Hirestar.io provides IT & ITeS background verification. Secure your workforce, mitigate risks, and ensure compliance with expert screening."
        />
        <meta
          name="keywords"
          content="IT employee verification, IT & ITeS background verification
          tech hiring compliance, ITES onboarding solutions, employment verification, IT employee screening, moonlighting checks It employee, white-collar background verification"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Background Verification for IT & ITeS | Hirestar.io"
        />

        <meta
          property="og:description"
          content="Hirestar.io provides IT & ITeS background verification. Secure your workforce, mitigate risks, and ensure compliance with expert screening."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/industries/it-ites"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Industry/Sector/IT_home_img.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Background Verification for IT & ITeS | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Hirestar.io provides IT & ITeS background verification. Secure your workforce, mitigate risks, and ensure compliance with expert screening."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Industry/Sector/IT_home_img.png"
        />
      </Helmet>
      {/* 1 section */}
      <ItHeroSection />
      {/* 2 section */}
      <div className="lg:mt-[24rem] md:mt-[12rem] mt-[8rem]">
        <BrandCarousel />
      </div>
      {/* 3 section */}
      {<BgvServiceSection Sector="IT/ITES Sector" />}
      {/* 4 section */}
      <ServicesCardSection Sector="IT/ITES Sector" Sector_cards="it" />
      <div className="mb-48">{<BgvStepsSection />}</div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
};

export default ItPage;
